
import React from 'react';
import ReactDOM from 'react-dom/client';

// ✅ Step 1: Bootstrap CSS Import (Ye sabse pehle)
import 'bootstrap/dist/css/bootstrap.min.css';

// ✅ Step 2: Your Custom CSS Files (Optional - agar banai hain to)
// Abhi ye files nahi hain, to COMMENT kar di hain
// import './styles/variables.css';
// import './styles/global.css';

// ✅ Step 3: Main App Component
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import 'bootstrap/dist/css/bootstrap.min.css';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <BrowserRouter>
      <App />
    </BrowserRouter>
  </React.StrictMode>
);
